module.exports = __webpack_public_path__ + "media/warning.1f981fff.wav";